import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";

import { assetService } from "../services/assetService";
import { systemService } from "../services/systemService";
import { partnerService, Partner } from "../services/partnerService";
import { partnerLineService } from "../services/partnerLineService";
import { partnerSatService } from "../services/partnerSatService";
import { partnerThaiLifeService } from "../services/partnerThaiLifeService";
import { partnerWellSuperAppService } from "../services/partnerWellSuperAppService";

import { getPartnerConfigField } from "../utils/getConfigs";
import { hospitalRedirectService } from "../utils/hospitalRedirectService";

const SuccessPage: React.FC = () => {
  const pageKey = "success";

  const redirectUrl = getPartnerConfigField("redirectUrl");

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [logo, setLogo] = useState<string | undefined>();
  const [partner, setPartner] = useState<Partner | undefined>();
  const system = systemService.getSystem(window.location);

  useEffect(() => {
    const currentPartner = partnerService.getPartner();
    if (!currentPartner) {
      navigate("/");
      return;
    }
    setPartner(currentPartner);

    // set logo
    const logoPath = assetService.getLogo(currentPartner.name);
    setLogo(logoPath);

    // // set language
    // i18n.changeLanguage(system.language);
  }, [navigate, i18n, system.language]);

  // TODO: set config in strapi to manage redirect URLs
  const handleSuccess = async () => {
    try {
      // Partner: Well Super App
      if (partnerWellSuperAppService.isActive()) {
        window.location.href = "https://well.dhv.life/";
        return;
      }

      // Partner: SAT.
      if (partnerSatService.isActive()) {
        window.location.href = "https://www.sat.or.th";
        return;
      }

      // Partner: ThaiLife.
      if (partnerThaiLifeService.isActive()) {
        window.location.href =
          "https://thailifeapplication.page.link/Samitivej";
        return;
      }

      // Partner: Line.
      if (partnerLineService.isActive()) {
        window.location.href = partnerLineService.getReturnUrl();
        return;
      }

      // Hospital-specific redirects (STH, SSH, SCH, SCT)
      const hospitalRedirectUrl = hospitalRedirectService.getRedirectUrl(
        partner?.name || "",
        localStorage.getItem("lang") ?? ""
      );
      if (hospitalRedirectUrl) {
        window.location.href = hospitalRedirectUrl;
        return;
      }

      // console.log("Redirect URL from config:", redirectUrl); // for debugging
      if (redirectUrl) {
        window.location.href = redirectUrl;
        return;
      }

      // Partner: Webview. (SNH and Sukhumvit)
      window.location.href =
        i18n.language === "en"
          ? "https://www.samitivejhospitals.com/center/detail/Virtual-Hospital"
          : "https://www.samitivejhospitals.com/th/center/detail/Virtual-Hospital";
    } catch (error) {
      console.error("Error during success redirect:", error);
    } finally {
      sessionStorage.removeItem("partnerInitialized");
    }
  };

  return (
    <div className="flex flex-col items-center p-4 md:p-10 gap-y-4 justify-center min-h-screen w-full">
      <div className="flex flex-col items-center p-0 md:p-10 gap-y-4 w-full">
        <div className="w-full max-w-3xl border p-10 rounded-3xl shadow-md bg-white items-center flex flex-col overflow-hidden">
          {/* Top section */}
          <div className="flex flex-col items-center">
            {/* Logo */}
            <div className="flex justify-center items-center">
              {logo && (
                <img
                  src={logo}
                  alt="Logo"
                  className="w-[172px] h-[64px] object-contain"
                />
              )}
            </div>

            {/* Thank you text */}
            <div className="w-full text-center mt-6 text-xl text-gray-800 mb-10">
              {t("pages.success.texts.thankYou")}
            </div>
          </div>

          {/* Finish button pinned to bottom */}
          <div className="w-full flex justify-center mt-8">
            <button
              id="dismissButton"
              onClick={handleSuccess}
              // className="w-full max-w-[340px] bg-svvh-green hover:bg-green-900 text-white font-medium py-3 px-6 rounded-3xl shadow transition"
              className="w-full max-w-[340px] gold-submit-btn  font-medium py-3 px-6 rounded-3xl shadow transition"
            >
              {t("pages.success.buttons.finish")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
